




import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import { CampaignStatus } from '@/modules/base-campaign/models/base-campaign-resource.model'

@Component
export default class ContentCampaignStatusView extends Vue {
  @Prop({ required: true }) status: CampaignStatus
  @Prop({ required: true }) statuses!: { [key in CampaignStatus]: string }
  @Prop({ default: false }) dark: boolean

  get statusColor() {
    switch (this.status) {
      case CampaignStatus.COMPLETED:
        return 'text-green'
      case CampaignStatus.CANCELLED:
        return 'text-red'
      case CampaignStatus.DRAFT:
        return this.dark ? 'text-white' : 'text-grey'
      case CampaignStatus.IN_PROGRESS:
        return this.dark ? 'text-orange' : 'text-amber-7'
      default:
        return ''
    }
  }
}
